import { useCallback } from 'react';

import { useApplicationConfig } from '@bonusly/application';

import { AppPath } from '../../top-navbar/config/router';
import { pathWithId } from '../../top-navbar/utils/api';

/**
 * Hook to get the profile path/URL for a user.
 *
 * @returns Object with:
 *   - getProfilePath: function that returns the relative path (for React Router navigation)
 *   - getProfileUrl: function that returns the full URL (for external links or href attributes)
 */
export const useProfilePath = () => {
	const recognizeOrigin = useApplicationConfig('recognizeOrigin');

	// Returns the path - use with components like UserNavLink that handle URL building
	const getProfilePath = useCallback((userId: string): string => {
		return pathWithId(AppPath.Profile, userId);
	}, []);

	// Returns the full URL - use for direct href attributes on <a> or <Link> elements
	// Always returns a full URL with origin for consistency
	const getProfileUrl = useCallback(
		(userId: string): string => {
			const path = pathWithId(AppPath.Profile, userId);
			return `${recognizeOrigin}${path}`;
		},
		[recognizeOrigin]
	);

	return {
		getProfilePath,
		getProfileUrl,
	};
};
